module.exports = __webpack_public_path__ + "static/media/koinvestor_detail.4bce098f.png";